import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useQueryParams } from '../hooks';

import { Pagination, PostCard } from '../components';

import { blogPosts } from '../copies';

const ITEMS_PER_PAGE = 10;

const Blog = () => {
  const history = useHistory();
  const query = useQueryParams();
  const [currentPage, setCurrentPage] = useState(
    parseInt(query.get('page')) || 1
  );

  // Indexes to retrieve the current page's blog posts
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  // Total number of pages
  const count = Math.ceil(blogPosts.length / ITEMS_PER_PAGE);

  const handleOnChangePage = newPage => {
    history.push(`?page=${newPage}`);
    setCurrentPage(newPage);
  };

  return (
    <section className="py-24 container max-w-screen-xl mx-auto space-y-24">
      <div className="text-center">
        <p className="text-primary-600 text-lg font-semibold tracking-wide uppercase">
          Learn
        </p>
        <h2 className="font-extrabold text-4xl sm:text-5xl mt-2">
          Helpful resources
        </h2>
        <p className="text-2xl text-center max-w-3xl mx-auto text-gray-500 mt-6">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Incidunt
          optio officiis dolore earum error eaque perferendis laudantium sed.
        </p>
      </div>

      <div className="space-y-12 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-8">
        {blogPosts.slice(startIndex, endIndex).map(post => (
          <div key={post.title}>
            <PostCard {...post} />
          </div>
        ))}
      </div>

      <div className="flex justify-center">
        <Pagination
          count={count}
          page={currentPage}
          onChange={handleOnChangePage}
        />
      </div>
    </section>
  );
};

export default Blog;
